import { useCallback, useMemo } from "react";

import { generateChartTraceColors } from "~/components/charts/Utils";
import { useSemanticColors } from "~/utils/Theme/useSemanticColors";

export const useTraceColors = () => {
  const colors = useSemanticColors();

  const seedColorHex = useMemo(
    () =>
      colors.mode === "dark"
        ? colors.utility.grayBlue[300]
        : colors.utility.grayBlue[600],
    [colors.mode, colors.utility.grayBlue],
  );

  const endColorHex = useMemo(
    () => (colors.mode === "dark" ? "#fac515" : "#cab504"),
    [colors.mode],
  );

  return useCallback(
    (quantity: number) =>
      generateChartTraceColors({
        quantity,
        seedColorHex,
        endColorHex,
      }),
    [seedColorHex, endColorHex],
  );
};
